export default __webpack_public_path__ + "static/media/6182d311c96b303babb6db5b88c23c4b1581009482518.89dec596.webp";